// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalUpdate_root__onHya","footer":"ModalUpdate_footer__1ThB4"};